<template>
  <div v-if="reusablePage && reusablePageId">
    <ReusablePageRenderer :reusablePage="reusablePage"></ReusablePageRenderer>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';
import ReusablePageRenderer from '@/components/ReusablePageRenderer.vue';
import { DKReusablePage } from '@/models/DKReusablePage';
import { DKMetaInfo } from '@/models/DKMetaInfo';
import { useActiveMeta, useMeta } from 'vue-meta';
import { generateMetaInfo } from '@/helpers/metainfo';

@Component({
  components: {
    ReusablePageRenderer,
  },
})
export default class ReusablePage extends Vue {
  get metaInfo(): DKMetaInfo {
    return {
      meta: (this.$metaInfoRef as any).meta,
      page: this.reusablePage,
      locale: this.$i18n?.locale || 'en-US',
      $route: this.$route,
    };
  }

  get reusablePageId(): string | null {
    return this.$store.getters['navigation/pageIdBySlug'](
      this.$route.params.slug
    );
  }

  get reusablePage(): DKReusablePage | null {
    return this.$store.getters['content/reusablePage'];
  }

  async serverPrefetch() {
    return Promise.all([
      this.$store.dispatch('content/fetchReusablePage', {
        id: this.reusablePageId,
        locale: this.$i18n.locale,
        $route: this.$route,
        $router: this.$router,
      }),
    ]).then(() => generateMetaInfo(this.metaInfo));
  }

  created() {
    this.$metaInfoRef = useMeta({ ...useActiveMeta() });
  }

  async mounted() {
    await this.$store.dispatch('content/fetchReusablePage', {
      id: this.reusablePageId,
      locale: this.$i18n.locale,
      $route: this.$route,
      $router: this.$router,
    });

    if (this.reusablePage?.footer) {
      this.$route.meta.defaultFooter = this.reusablePage?.footer;
    }

    const meta = generateMetaInfo(this.metaInfo);

    this.$trackView('reusable_page', meta.title);
  }

  beforeUnmount() {
    this.$store.commit('content/clearReusablePage');
  }
}
</script>
